<div *ngIf="global_texts" class="all-content login">
  <div class="content">
    <div class="inner-content w-100">
      <div class="left-module bloc-image"></div>
      <div class="right-module py-0 px-5 py-lg-5 justify-content-center align-items-center">

        <app-logos-unlogged></app-logos-unlogged>

        <div class="py-4 d-flex flex-column justify-content-center align-items-center"
             style="align-self: normal;">

          <!-- Bubble Title Login -->
          <div class="bubble-step mb-5 bloc-login-form">
            <div class="title">
              <h1 [innerHtml]="page_texts.title"></h1>
            </div>

            <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
              <h6 class="mb-3 fw-semi-bold" [innerHtml]="page_texts.text_info"></h6>


              <!-- password -->
              <div class="mb-4">
                <input class="form-control with-picto mdp" [attr.placeholder]="page_texts.password"
                       type="password" formControlName="password" autocomplete="new-password">
                <!-- Error Messages -->
                <div *ngIf="submitted && resetForm.controls['password'].errors" class="small fw-bold color-red mt-2">
                  <div
                    *ngIf="resetForm.controls['password'].errors"
                    [innerHtml]="app.sharedHelper.getErrorMessage('password', global_texts, resetForm.controls)">
                  </div>
                </div>
              </div>

              <!-- confirm password -->
              <div class="mb-4">
                <input class="form-control with-picto mdp" [attr.placeholder]="page_texts.password_confirm"
                       type="password" formControlName="confirm_password" autocomplete="new-confirm_password">
                <!-- Error Messages -->
                <div *ngIf="submitted && resetForm.controls['confirm_password'].errors"
                     class="small fw-bold color-red mt-2">
                  <div
                    *ngIf="resetForm.controls['confirm_password'].errors"
                    [innerHtml]="app.sharedHelper.getErrorMessage('confirm_password', global_texts, resetForm.controls)">
                  </div>
                </div>
              </div>

              <!-- Send Email And Cancel buttons -->
              <div class="d-flex flex-column flex-md-row justify-content-around w-100 gap-3 my-4">
                <button type="submit" class="btn btn-solid-green" [innerHtml]="global_texts.save"></button>
              </div>
            </form>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

